import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Popover,
} from '@mui/material';
import React from 'react';

export type CheckboxFilter = {
  [name: string]: {
    [key: string]: boolean;
  };
};

interface TableCheckboxFilterProps {
  anchorEl: HTMLButtonElement | null;
  anchorId: string;
  checkboxFilters: CheckboxFilter;
  handleClose: () => void;
  onItem: (filterName: string, key: string, value: boolean) => void;
  onSelectAll: (filterName: string) => void;
  onUnselectAll: (filterName: string) => void;
}

export const TableCheckboxFilter = ({
  anchorEl,
  anchorId,
  checkboxFilters,
  handleClose,
  onItem,
  onSelectAll,
  onUnselectAll,
}: TableCheckboxFilterProps) => {
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      {checkboxFilters && checkboxFilters[anchorId] && (
        <>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyItems: 'center',
              py: 2,
              px: 4,
              borderBottom: '1px solid grey',
            }}
            className="flex items-center justify-center  border-b sticky top-0 bg-white z-10"
          >
            <Button
              color="primary"
              size="small"
              onClick={() => onSelectAll(anchorId)}
            >
              Reset
            </Button>

            <Button
              variant="contained"
              color="primary"
              size="small"
              sx={{ ml: 2 }}
              onClick={() => onUnselectAll(anchorId)}
            >
              Uncheck all
            </Button>
          </Box>

          <Box sx={{ px: 4, py: 2 }}>
            <FormControl component="fieldset">
              <FormGroup>
                {Object.entries(checkboxFilters[anchorId]).map(
                  ([key, value], index) => (
                    <FormControlLabel
                      key={`filter-checkbox-${index}`}
                      control={
                        <Checkbox
                          color="primary"
                          checked={value}
                          onChange={() => onItem(anchorId, key, !value)}
                        />
                      }
                      label={key}
                    />
                  )
                )}
              </FormGroup>
            </FormControl>
          </Box>
        </>
      )}
    </Popover>
  );
};
